import Map from "@/components/Map";
import React from "react";
import Image from "next/image";
import Spinner from "@/components/Spinner";
import Marker, { MapMarker } from "@/components/Map/Marker";
import { Wrapper, Status } from "@googlemaps/react-wrapper";

interface Props {
  locations: MapMarker[];
}

const CommunityMap: React.FC<Props> = ({ locations }) => {
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS;

  const render = (status: Status) => {
    return status === Status.FAILURE ? (
      <div className="h-full w-full">
        <Image
          src="/images/Community_map.png"
          layout="fill"
          objectFit="cover"
          priority={true}
          alt=""
        />
      </div>
    ) : (
      <Spinner />
    );
  };

  return apiKey ? (
    <Wrapper apiKey={apiKey} render={render}>
      <Map
        zoom={7}
        center={{ lat: 52.2682631, lng: 5.1056147 }}
        mapTypeControl={false}
        fullscreenControl={false}
        streetViewControl={false}
      >
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={{ lat: location.lat, lng: location.lng }}
            icon={{ url: location.icon ? location.icon : "" }}
            content={
              location.address === null
                ? `
                    <p class="text-slate-900 text-base font-medium">${location.name}</p>
                  `
                : `
                    <p class="text-slate-900 text-base font-medium">${location.name}</p>
                    <p class="text-slate-700 text-sm">${location.address}</p>
                  `
            }
          />
        ))}
      </Map>
    </Wrapper>
  ) : null;
};

export default CommunityMap;
